import React, {Fragment,useState,useEffect,Suspense} from 'react';
import { Table,Row, Col,
  Card, CardBody,
  CardTitle,Button,FormGroup,Label,Input } from 'reactstrap';
import Parametri from '../../parametri';

import TabellaRicerca from '../tabellaricerca.js';

import Clessidra from '../Clessidra.js';
import {haPersonalizzazione} from '../../funzioni.js';

import Interrogativo from '../../immagini/interrogativo-azzurro.png';


//const STATO_INDEFINITO = 0;
const STATO_RICERCA_DATI_INIZIALI = 1;
const STATO_RICERCA_ELENCO = 2;
const STATO_ELENCO = 3;
const STATO_ERRORE_CONNESSIONE = 4;
const STATO_VAI_IN_INSERISCI = 5;

function TabellaAssemblee(props) {
    
  const { tipo } = props;

  const oggiAAAAMMDD = new Date().toLocaleDateString('en-CA'); // en-CA per avere la data nella forma AAAA-MM-DD
    
  const [elencoAssemblee,setElencoAssemblee] = useState('');

  // elencoConvocati: [
  //   { id, nome, email, ruolo }
  // ]
  const [elencoConvocati, setElencoConvocati] = useState([]);

  // --- DATI CONVOCAZIONE ---
  const [dataPrima, setDataPrima] = useState("");     // YYYY-MM-DD
  const [oraPrima, setOraPrima] = useState("18:00");  // HH:mm
  const [dataSeconda, setDataSeconda] = useState(""); // YYYY-MM-DD
  const [oraSeconda, setOraSeconda] = useState("19:00"); // HH:mm

  const [luogo, setLuogo] = useState("");
  const [titolo, setTitolo] = useState("");

  const [tipoAssemblea, setTipoAssemblea] = useState("ordinaria"); // "ordinaria" | "straordinaria"

  // --- ORDINE DEL GIORNO (A PUNTI) ---
  const [odg, setOdg] = useState([
  ]);
  // struttura:
  // [{ id: number, testo: string }]

  // --- EMAIL CONVOCAZIONE ---
  const [inviaEmailSubito, setInviaEmailSubito] = useState(true);
  const [oggettoEmail, setOggettoEmail] = useState("");
  const [testoEmail, setTestoEmail] = useState("");
  const [copiaConoscenzaEmail, setCopiaConoscenzaEmail] = useState("");
  
  // in futuro:
  // const [allegati, setAllegati] = useState([]);
  // [{ tipo: "bilancio" | "file", idDocumento, nomeFile }]

  // --- DESTINATARI EMAIL (SELEZIONE) ---
  const [emailSelezionati, setEmailSelezionati] = useState(new Set()); // contiene gli id dei convocati con email selezionata

  // --- AUTO COMPILAZIONE EMAIL ---
  const [oggettoEmailAuto, setOggettoEmailAuto] = useState(true);
  const [testoEmailAuto, setTestoEmailAuto] = useState(true);

  // --- NOTE INTERNE ---
  const [noteInterne, setNoteInterne] = useState("");

  // --- STATO UI / VALIDAZIONE ---
  const [errore, setErrore] = useState("");

  const [statoPagina,setStatoPagina] = useState(STATO_RICERCA_DATI_INIZIALI);
  const [error,setError] = useState('');
  
  // nota: accessor DEVE chiamarsi così a causa di requisiti dei componenti usati, non fatti da me
  const colonne = [
    {
      etichetta: '',
      accessor: 'ID'
    },
    {
      etichetta: 'Prima Conv.',
      accessor: 'DATA_PRIMA',
      pdf: 1,
    },
    {
      etichetta: "Seconda Conv.",
      accessor: 'DATA_SECONDA',
      pdf: 1,
    },
    {
      etichetta: "Ordine del Giorno",
      accessor: 'ODG',
      pdf: 1,
    },
  ];
  const arrayTipiDati=[];

  function aggiungiPuntoOdg() {
    setOdg((prev) => {
      const maxId = prev.reduce((m, x) => Math.max(m, x.id), 0);
      return [...prev, { id: maxId + 1, testo: "" }];
    });
  }

  useEffect(() => {
    //if (tipo == "soci") scaricaElencoSoci();
    if (tipo == "direttivo") scaricaElencoDirettivo();
    setErrore("");
    if (!haPersonalizzazione(props.identitaSelezionata, "smtp")) setInviaEmailSubito(false);
  },[])

  useEffect(() => {
    if(statoPagina===STATO_RICERCA_ELENCO){
      // parametri per inviare i dati al server:
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({op:"assembleeElenco",tipo:props.tipo,emak: props.emak,sessionId:props.sessionId})
      };
  
      fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
        .then(risposta => risposta.json())
        .then(
          (valoreDiRitorno) => {
            if(valoreDiRitorno.risultatoOperazione===0){
              alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
            }
            if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
            if(valoreDiRitorno.risultatoOperazione===1){
              setElencoAssemblee(valoreDiRitorno.elenco);
              setStatoPagina(STATO_ELENCO);}
          },
        (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
        );
    }    
  },[statoPagina])

  // Autocompilazione titolo email = titolo
  useEffect(() => {
    if (!inviaEmailSubito) return;
    if (!oggettoEmailAuto) return;
    setOggettoEmail((titolo || "").trim());
  }, [titolo, inviaEmailSubito, oggettoEmailAuto]);

  // Autocompilazione testo email = template (dipende da vari campi)
  useEffect(() => {
    if (!inviaEmailSubito) return;
    if (!testoEmailAuto) return;
    setTestoEmail(generaTestoEmail());
  }, [inviaEmailSubito, testoEmailAuto, tipo, tipoAssemblea, dataPrima, oraPrima, dataSeconda, oraSeconda, luogo, odg]);

function cambiaTestoOdg(id, valore) {
    setOdg((prev) =>
      prev.map((x) => (x.id === id ? { ...x, testo: valore } : x))
    );
  }

  function rimuoviPuntoOdg(id) {
    setOdg((prev) => prev.filter((x) => x.id !== id));
  }

  function VaiModifica(id) {
    //setStatoPagina(STATO_VAI_IN_MODIFICA);
    //setIdModifica(id);
  }

  function VaiElimina(id) {
    //setStatoPagina(STATO_VAI_IN_ELIMINA);
    //setIdModifica(id);
  }

  function scaricaElencoDirettivo() {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({op:"elencoPersoneDirettivo",
          emak: props.emak,
          radioPeriodo: 3,
          dataInizioPeriodo:oggiAAAAMMDD,
          dataFinePeriodo:oggiAAAAMMDD,
          sessionId:props.sessionId})
      };
  
      fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
        .then(risposta => risposta.json())
        .then(
          (valoreDiRitorno) => {
            if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
              alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
            }
            if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
            if(valoreDiRitorno.risultatoOperazione===1){
              setElencoConvocati(valoreDiRitorno.risultatoRitorno[0].sociAnnoInCorso);
              // preseleziona tutti quelli che hanno email
              const s = new Set();
              elencoConvocati.forEach(p => {
                if (p.EMAIL && p.EMAIL.trim() !== "") s.add(p.id);
              });
              setEmailSelezionati(s);
              setStatoPagina(STATO_RICERCA_ELENCO);}
          },
        (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
        );
  }

  function formattaDataIT(yyyy_mm_dd) {
    if (!yyyy_mm_dd) return "";
    const p = yyyy_mm_dd.split("-");
    if (p.length !== 3) return yyyy_mm_dd;
    return p[2] + "/" + p[1] + "/" + p[0];
  }

  function generaTestoEmail() {
    const destinatari = (tipo === "direttivo") ? "componenti del direttivo" : "signori soci";
    const tipoAss = (tipoAssemblea === "straordinaria") ? "straordinaria" : "ordinaria";

    const riga1 = `Si avvisano i ${destinatari} che è convocata l'assemblea ${tipoAss}.`;
    const riga2 = `Prima convocazione il ${formattaDataIT(dataPrima)} alle ${oraPrima}.`;
    const riga3 = `Seconda convocazione il ${formattaDataIT(dataSeconda)} alle ${oraSeconda}.`;
    const riga4 = `Presso: ${luogo || ""}.`;
    const riga5 = `Per discutere e deliberare sul seguente ordine del giorno:`;

    const odgPulito = odg.map(x => (x.testo || "").trim()).filter(Boolean);
    const righeOdg = odgPulito.length
      ? odgPulito.map((t, i) => `${i + 1}) ${t}`)
      : ["- (ordine del giorno non definito)"];

    return [
      riga1,
      "",
      riga2,
      riga3,
      riga4,
      "",
      riga5,
      ...righeOdg,
      "",
      "Cordiali saluti.",
    ].join("\n");
  }



  // temporanea attivazione solo per EMA18
  if (props.identitaSelezionata.nome_database!="EMA18") return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>Funzione presto disponibile</div>)

  if (statoPagina == STATO_RICERCA_DATI_INIZIALI || statoPagina == STATO_RICERCA_ELENCO) {
    return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/></div>)
  }

  if (statoPagina == STATO_ERRORE_CONNESSIONE) {
    return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>Errore nella ricerca dei dati</div>)
  }

  if (statoPagina == STATO_ELENCO) {
    return (
      <div style={{height: props.dimensioniApp.yMain, overflow:"hidden", display:"flex", flexDirection:"column"}}>
      <CardBody>
    
      <div>
        <CardTitle>Elenco assemblee {props.tipo=="soci" && " dei soci"}{props.tipo=="direttivo" && " del direttivo"}</CardTitle>
        <Button color="success" onClick={() => setStatoPagina(STATO_VAI_IN_INSERISCI)}>Nuova Assemblea</Button>
      </div>
      </CardBody>
      {elencoAssemblee ?
        <TabellaRicerca 
          titolo={`Elenco Assemblee`} 
          columns={colonne} data={elencoAssemblee} arrayTipiDati={arrayTipiDati} campoChiave={0} campoOrdinamento={1} nascondiColonna={0} callbackSelezionaElemento={VaiModifica} callbackEliminaElemento={VaiElimina}/>
        : 
          <div>Nessun dato presente</div>
      }
                    
    </div>
    )
  }

  if (statoPagina == STATO_VAI_IN_INSERISCI) {

    function valida() {
      if (!dataPrima) return "Inserisci la data della 1ª convocazione.";
      if (!dataSeconda) return "Inserisci la data della 2ª convocazione.";
      if (dataSeconda < dataPrima) return "La 2ª convocazione non può essere prima della 1ª.";
      if (!luogo.trim()) return "Inserisci il luogo.";
      if (!titolo.trim()) return "Inserisci un titolo/oggetto dell'assemblea.";
      const odgPulito = odg.map((x) => x.testo.trim()).filter(Boolean);
      if (odgPulito.length === 0) return "Inserisci almeno un punto nell'ordine del giorno.";
      if (elencoConvocati.length === 0) return "Elenco convocati vuoto.";
      if (inviaEmailSubito) {
        const selezionati = elencoConvocati.filter(c => c.EMAIL && c.EMAIL.trim() !== "" && emailSelezionati.has(c.id));
        if (selezionati.length === 0) return "Seleziona almeno un destinatario con email.";
        if (!oggettoEmail.trim()) return "Inserisci l'oggetto email.";
        if (!testoEmail.trim()) return "Inserisci il testo email.";
      }
      return "";
    }

    function invia_convocazione_backend() {
      const msg = valida();
      if (msg) {
        alert(msg);
        setErrore(msg);
        return;
      }
      setErrore("");

      const destinatariEmail = elencoConvocati.filter(c => c.EMAIL && c.EMAIL.trim() !== "" && emailSelezionati.has(c.id));

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({op:"aggiungiAssemblea",
        emak: props.emak,
        tipo: tipo,
        tipo, // "soci" | "direttivo"
        dataPrima: dataPrima+"T"+oraPrima,        
        dataSeconda: dataSeconda+"T"+oraSeconda,
        luogo: luogo.trim(),
        titolo: titolo.trim(),
        odg: odg.map((x) => x.testo.trim()).filter(Boolean),
        convocati: elencoConvocati,
        email: {
          inviaEmailSubito,
          oggetto: oggettoEmail.trim(),
          testo: testoEmail,
          destinatari: destinatariEmail,  // <-- SOLO quelli selezionati e con email
          copiaConoscenzaEmail: copiaConoscenzaEmail
        },
        noteInterne: noteInterne.trim(),
        sessionId:props.sessionId})
      };
  
      fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
        .then(risposta => risposta.json())
        .then(
          (valoreDiRitorno) => {
            if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
              alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
            }
            if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
            if(valoreDiRitorno.risultatoOperazione===1){              
              setStatoPagina(STATO_RICERCA_ELENCO);}
          },
        (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
      );
    }

    return (
      <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
      <CardBody>
        <CardTitle>
          Nuova Convocazione {tipo === "direttivo" ? "Direttivo" : "Assemblea Soci"}
          &nbsp;
          {/* se vuoi l’help come nelle altre pagine */}
          {/* <img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagModaleInfo(true)}/> */}
        </CardTitle>

        {errore ? (
          <Row style={{ marginLeft: 20, marginRight: 20 }} >
            <Col style={{ color: "red", padding: 10 }}>
              <b>{errore}</b>
            </Col>
          </Row>
        ) : (
          ""
        )}

        {/* ======= DATI CONVOCAZIONE ======= */}
        {/*
        <Row
          style={{ marginLeft: 20, marginRight: 20, backgroundColor: "#99cbff" }}
          
        >
          <Col>
            <b>
              <center>Dati Convocazione</center>
            </b>
          </Col>
        </Row>
        */}
        <div className='schedaSottotitolo'>Dati Convocazione</div>

        <Row style={{ marginLeft: 20, marginRight: 20 }}>
          <Col md="6">
            <FormGroup style={{ paddingTop: 5 }}>
              <Label for="dataPrima">1ª convocazione</Label>
              <div style={{display:'flex', flexDirection:'row'}}>
                <Input
                  maxLength={10}
                  type="date"
                  name="dataPrima"
                  id="dataPrima"
                  value={dataPrima}
                  onChange={(e) => setDataPrima(e.target.value)}
                />
                <Input
                  type="time"
                  name="oraPrima"
                  id="oraPrima"
                  value={oraPrima}
                  onChange={(e) => setOraPrima(e.target.value)}
                />
              </div>
            </FormGroup>
          </Col>

          <Col md="6">
            <FormGroup style={{ paddingTop: 5 }}>
              <Label for="dataSeconda">2ª convocazione</Label>
              <div style={{display:'flex', flexDirection:'row'}}>
                <Input
                  maxLength={10}
                  type="date"
                  name="dataSeconda"
                  id="dataSeconda"
                  value={dataSeconda}
                  onChange={(e) => setDataSeconda(e.target.value)}
                />
                <Input
                  type="time"
                  name="oraSeconda"
                  id="oraSeconda"
                  value={oraSeconda}
                  onChange={(e) => setOraSeconda(e.target.value)}
                />
              </div>
            </FormGroup>
          </Col>
        </Row>

        <Row style={{ marginLeft: 20, marginRight: 20 }} >
          <Col md="12">
            <FormGroup>
              <Label for="luogo">Luogo</Label>
              <Input
                type="text"
                name="luogo"
                id="luogo"
                value={luogo}
                placeholder="indirizzo oppure, ad es., Sede Sociale"
                onChange={(e) => setLuogo(e.target.value)}
              />
            </FormGroup>
          </Col>          
        </Row>

        <Row style={{ marginLeft: 20, marginRight: 20 }} >
          <Col md="3">
            <FormGroup>
              <Label for="tipoAssemblea">Tipo assemblea</Label>
              <select
                className="inputStandard" 
                type="select"
                name="tipoAssemblea"
                id="tipoAssemblea"
                value={tipoAssemblea}
                onChange={(e) => setTipoAssemblea(e.target.value)}
              >
                <option value="ordinaria">Ordinaria</option>
                <option value="straordinaria">Straordinaria</option>
              </select>
            </FormGroup>
          </Col>

          <Col md="9">
              <Label for="titolo">Titolo / Oggetto</Label>
              <Input
                type="text"
                name="titolo"
                id="titolo"
                value={titolo}
                placeholder="Es. Convocazione assemblea ordinaria"
                onChange={(e) => setTitolo(e.target.value)}
              />
          </Col>
        </Row>        

        {/* ======= ORDINE DEL GIORNO ======= */}        
        <div className='schedaSottotitolo'>Ordine del Giorno</div>

        <Row style={{ marginLeft: 20, marginRight: 20 }} >
          <Col style={{ padding: 10 }}>
            {odg.map((punto, idx) => (
              <Row key={punto.id} style={{ marginBottom: 10 }}>
                <Col md="1" style={{ paddingTop: 8 }}>
                  <b>{idx + 1}.</b>
                </Col>
                <Col md="9">
                  <Input
                    type="text"
                    value={punto.testo}
                    placeholder="Inserisci punto ODG..."
                    onChange={(e) => cambiaTestoOdg(punto.id, e.target.value)}
                  />
                </Col>
                <Col md="2">
                  <Button
                    color="danger"
                    onClick={() => rimuoviPuntoOdg(punto.id)}
                    style={{ width: "100%" }}
                  >
                    Rimuovi
                  </Button>
                </Col>
              </Row>
            ))}

            <Button color="success" onClick={() => aggiungiPuntoOdg()}>
              + Aggiungi punto
            </Button>
          </Col>
        </Row>

        {/* ======= CONVOCATI (SELEZIONE EMAIL) ======= */}
        <div className='schedaSottotitolo'>Convocati: {elencoConvocati.length}</div>

        <Row style={{ marginLeft: 20, marginRight: 20 }}>
          <Col>
            {elencoConvocati.length === 0 ? (
              <div><b>Elenco convocati vuoto (verifica che esistano {tipo=="soci"?"soci":"componenti del direttivo"}).</b></div>
            ) : (
              <div style={{ paddingLeft:10, paddingRight: 10 }}>
                {elencoConvocati.map((c, i) => {
                  const haEmail = c.EMAIL && c.EMAIL.trim() !== "";
                  const selezionato = emailSelezionati.has(c.id);

                  return (
                    <Row key={c.id}>
                      <Col md="6" style={{borderBottom: i==elencoConvocati.length-1 ? "" : "1px solid #D0D0D0"}}>
                        <b>{c.COGNOME} {c.NOME} {c.NUMERO_TESSERA!="" && (c.NUMERO_TESSERA)}</b>
                        <div style={{fontSize:12}}>{c.POSIZIONI}</div>
                      </Col>

                      <Col md="6" style={{borderBottom: i==elencoConvocati.length-1 ? "" : "1px solid #D0D0D0"}}>
                          {inviaEmailSubito ? (
                          haEmail ? (
                            <Input
                              type="checkbox"
                              checked={selezionato}
                              onChange={(e) => {
                                const nuovo = new Set(emailSelezionati);
                                if (e.target.checked) nuovo.add(c.id);
                                else nuovo.delete(c.id);
                                setEmailSelezionati(nuovo);
                              }}
                            />
                          ) : (
                            <Input type="checkbox" disabled />
                          )
                        ) : ""}

                        <i>{haEmail ? c.EMAIL : <span style={{color:"#FF5050"}}>non ha email</span>}</i>
                      </Col>

                    </Row>
                  );
                })}
              </div>
            )}
          </Col>
        </Row>

        {inviaEmailSubito &&
          <div style={{ padding: 10, display: "flex", gap: 10 }}>
            <Button
              color="primary"
              onClick={() => {
                const s = new Set();
                elencoConvocati.forEach(p => {
                  if (p.EMAIL && p.EMAIL.trim() !== "") s.add(p.id);
                });
                setEmailSelezionati(s);
              }}
            >
              Seleziona tutti
            </Button>

            <Button
              color="secondary"
              onClick={() => setEmailSelezionati(new Set())}
            >
              Seleziona nessuno
            </Button>
          </div>
        }

        {/* ======= EMAIL + ALLEGATI (FUTURI) ======= */}        
        <div className='schedaSottotitolo'>Invio Email</div>

        <Row style={{ marginLeft: 20, marginRight: 20 }} >
          <Col style={{ padding: 10 }}>
            {haPersonalizzazione(props.identitaSelezionata, "smtp") ? 
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  checked={inviaEmailSubito}
                  onChange={(e) => setInviaEmailSubito(e.target.checked)}
                />{" "}
                Invia email ai {elencoConvocati.filter(c => c.EMAIL && c.EMAIL.trim() !== "" && emailSelezionati.has(c.id)).length} convocati selezionati
              </Label>
            </FormGroup>
            :
              <div style={{color:"#FF0000"}}>Impossibile inviare email di convocazione, prima definisci l'SMTP in Impostazioni - Società</div>
            }

            <Row style={{ marginTop: 10 }}>
              <Col md="12">
                <FormGroup>
                  <Label for="oggettoEmail">Oggetto email</Label>
                  <Input
                    type="text"
                    name="oggettoEmail"
                    id="oggettoEmail"
                    value={oggettoEmail}
                    onChange={(e) => { setOggettoEmailAuto(false); setOggettoEmail(e.target.value); }}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <FormGroup>
                  <Label for="testoEmail">Testo email</Label>
                  <Input
                    type="textarea"
                    name="testoEmail"
                    id="testoEmail"
                    rows="8"
                    value={testoEmail}
                    onChange={(e) => { setTestoEmailAuto(false); setTestoEmail(e.target.value); }}
                  />

                  <div style={{ marginTop: 10 }}>
                    <Button
                      color="primary"
                      onClick={() => { setTestoEmailAuto(true); setTestoEmail(generaTestoEmail()); }}
                    >
                      Rigenera automaticamente oggetto e testo
                    </Button>
                  </div>
                </FormGroup>
              </Col>
            </Row>

            {inviaEmailSubito &&
              <Row style={{ marginTop: 10 }}>
                <Col md="12">
                  <FormGroup>
                    <Label for="copiaConoscenzaEmail">Manda convocazione in copia a questi indirizzi email (separati da virgola)</Label>
                    <Input
                      type="text"
                      name="copiaConoscenzaEmail"
                      id="copiaConoscenzaEmail"
                      value={copiaConoscenzaEmail}
                      onChange={(e) => { setCopiaConoscenzaEmail(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
              </Row>                
            }
          </Col>
        </Row>

        {/* ======= NOTE INTERNE ======= */}
        <div className='schedaSottotitolo'>Note Interne</div>
        <Row style={{ marginLeft: 20, marginRight: 20 }} >
          <Col style={{ padding: 10 }}>
            <FormGroup>
              <Input
                type="textarea"
                name="noteInterne"
                id="noteInterne"
                rows="4"
                value={noteInterne}
                onChange={(e) => setNoteInterne(e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>

        {/* ======= BOTTONI ======= */}
        <div style={{ marginTop: 15 }}>
          <Button color="success" onClick={() => invia_convocazione_backend()}>
            Memorizza{inviaEmailSubito && " e invia convocazione"}
          </Button>
          <Button
            color="secondary"
            className="bottoneMargineASinistra"
            onClick={() => setStatoPagina(STATO_RICERCA_ELENCO)}
          >
            Annulla
          </Button>
        </div>
      </CardBody>
      </div>
    );
  }
  
  
  return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>Assemblee: Pagina non trovata ({statoPagina})</div>)
}
export default TabellaAssemblee;